import { render, staticRenderFns } from "./AllocationRecipientTable.vue?vue&type=template&id=71f4fdf3"
import script from "./AllocationRecipientTable.vue?vue&type=script&lang=js"
export * from "./AllocationRecipientTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports